
function vcFormValidation(visual, btnSave) {
    /// <summary>
    /// This object provides client-side functions for the manual validation of vcFormItems. <br/>
    /// <br/>
    /// Author: AFU<br />
    /// Date: 7.07.2016<br />
    /// Copyright ©: EUDT GmbH 2016 <br />
    /// Version-History:<br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 7.06.2016                                               *<br />
    /// **********************************************************************<br />
    /// * - basic functionality                                              *<br />
    /// **********************************************************************<br />
    /// </summary>
    /// visual object of the main widget
    this.visual = visual;
    // save button object of the main widget
    this.btnSave = btnSave;
    
}
vcFormValidation.prototype = new vcTemplate();

vcFormValidation.prototype.validate = function (id, valAttr) {
    /// <summary>
    /// This function inits the validation for an html object given by the id.<br/>
    /// The valAttr contains the validation type, min and max-values - eg: 'text;5;250', 'number;-9999,9999'
    /// </summary>
    var me = this;
    var bIsMandatory, err;

    try {

        //first of all - check if a mandatory field is not empty
        var val = me.visual.find('#' + id).val();
        if (val === null) {
            val = '';
        } else {
            val = val + '';
        }
        val = trimAll(val);

        bIsMandatory = me.visual.find('#box' + id).hasClass('mandatory');
        //validate the value based on the validation settings
        err = me.checkValidationType(val, valAttr, bIsMandatory);
        if (bIsMandatory) {
            if (validateNotEmpty(val) === false) {

                if (err.length === 0) {
                    err = getFormErrorMsg(1);
                }
                me.setInvalid(id, err);
            }
        }
        if (err.length === 0) {
            me.setValid(id);
        } else {
            me.setInvalid(id, err);
        }


        me.checkValidState();
    } catch (ex) {
        writeError('vcFormValidation.validate', ex);
        return false;
    }
    return false;
};

vcFormValidation.prototype.checkValidationType = function (val, valAttr, bIsMandatory) {
    /// <summary>
    /// This function parses the valAttr and validates the val based on the validation settings.<br/>
    /// The valAttr contains the validation type, min and max-values - eg: 'text;5;250', 'number;-9999,9999'<br/>
    /// The function returns an empty string if everything is valid or an error message on error.
    /// </summary>
    var attr, min, max, type;
    try {
        attr = valAttr.split(';');
        type = attr[0];
        min = parseInt(attr[1], 10);
        max = parseInt(attr[2], 10);
        switch (type) {
            case 'none':
                return '';
            case 'text':
                if (val.length < min) {
                    return getFormErrorMsg(2) + ' ' + min + ' ' + getFormErrorMsg(4);
                }
                if (val.length > max) {
                    return getFormErrorMsg(3) + ' ' + max + ' ' + getFormErrorMsg(4);
                }
                return '';
            case 'email':
                if (val.length < min) {
                    return getFormErrorMsg(2) + ' ' + min + ' ' + getFormErrorMsg(4);
                }
                if (val.length > max) {
                    return getFormErrorMsg(3) + ' ' + max + ' ' + getFormErrorMsg(4);
                }
                if (val.length > 0 && validateEmail(val) === false) {
                    return getFormErrorMsg(5);
                } else {
                    return '';
                }
            case 'url':
                if (val.length < min) {
                    return getFormErrorMsg(2) + ' ' + min + ' ' + getFormErrorMsg(4);
                }
                if (val.length > max) {
                    return getFormErrorMsg(3) + ' ' + max + ' ' + getFormErrorMsg(4);
                }
                if (val.length > 0 && validateUrl(val) === false) {
                    return getFormErrorMsg(6);
                } else {
                    return '';
                }
            case 'phone':
                if (val.length < min) {
                    return getFormErrorMsg(2) + ' ' + min + ' ' + getFormErrorMsg(4);
                }
                if (val.length > max) {
                    return getFormErrorMsg(3) + ' ' + max + ' ' + getFormErrorMsg(4);
                }
                if (val.length > 0 && validatePhone(val) === false) {
                    return getFormErrorMsg(7);
                }
                if (val.length > 1 && val.substring(0, 2) !== '00') {
                    return getFormErrorMsg(7);
                } else {
                    return '';
                }
            case 'number':
                if (val.length === 0 && bIsMandatory === false) {
                    return '';
                }
                if (validateNumeric(val) === false) {
                    return getFormErrorMsg(8);
                }
                if (parseInt(val, 10) < min) {
                    return getFormErrorMsg(9) + ' ' + (min - 1) + ' ' + getFormErrorMsg(11);
                }
                if (parseInt(val, 10) > max) {
                    return getFormErrorMsg(10) + ' ' + (max + 1) + ' ' + getFormErrorMsg(11);
                }
                return '';
            case 'integer':
                if (validateInteger(val) === false) {
                    return getFormErrorMsg(8);
                }
                if (parseInt(val, 10) < min) {
                    return getFormErrorMsg(9) + ' ' + (min - 1) + ' ' + getFormErrorMsg(11);
                }
                if (parseInt(val, 10) > max) {
                    return getFormErrorMsg(10) + ' ' + (max + 1) + ' ' + getFormErrorMsg(11);
                }
                return '';
            case 'date':
                if (isDate(val) === false) {
                    return getFormErrorMsg(12);
                } else {
                    return '';
                }
            case 'telnr':

            if (val.length === 0 && bIsMandatory === false) { return '' }
            val = val.replace(/ /g, '');
            if (val.length < min) { return getFormErrorMsg(2) + ' ' + min + ' ' + getFormErrorMsg(4);}
            if (val.length > max) { return getFormErrorMsg(3) + ' ' + max + ' ' + getFormErrorMsg(4);}
            if (val.length > 0 && validateNumeric(val) === false) { return getFormErrorMsg(7) } 
            if (val.length > 0 && val.substring(0,1) === '0') { return getFormErrorMsg(7) } else { return ''}
        }
    } catch (ex) {
        writeError('vcFormValidation.checkValidationType', ex);
        return false;
    }
    return true;
};


vcFormValidation.prototype.setValid = function (id) {
    /// <summary>
    /// This function sets an form item to valid<br/>
    /// </summary>
    var me = this;
    try {
    me.visual.find('#box' + id).removeClass('formItemInvalid').addClass('formItemValid');
    me.visual.find('#imgValidation' + id).html("<i class='fa fa-check icon-color-ok' style='font-size:16px;'></i>").attr('title', '').unbind();
    return true;
    } catch (ex) { writeError('vcFormValidation.setValid', ex); return false; }
};

vcFormValidation.prototype.setInvalid = function (id, msg) {
    /// <summary>
    /// This function sets an form item to invalid aand adds the error message to the error icon<br/>
    /// </summary>
    var me = this;
    try {
    me.visual.find('#box' + id).removeClass('formItemValid').addClass('formItemInvalid');
        me.visual.find('#imgValidation' + id).html("<i class='fa-regular fa-times-circle icon-color-error' style='font-size:16px;'></i>").attr('title', msg).tipTip({ defaultPosition: 'top' });
    return true;
    } catch (ex) { writeError('vcFormValidation.setInvalid', ex); return false; }
};

vcFormValidation.prototype.checkValidState = function () {
    /// <summary>
    /// This function validates all form items - if at least one invalid form item was found the save button gets deactivates.<br/>
    /// </summary>
    var me = this;
    try {
    if (me.visual.find('.formItemInvalid').length === 0) {
        me.btnSave.button("enable");
    } else {
        me.btnSave.button("disable");
    }
    return true;
    } catch (ex) { writeError('vcFormValidation.checkValidState', ex); return false; }
};